import React, { Component } from 'react';


class ServiceTerms extends Component {
  
// const ServiceTerms = () => (

  render() {
    return (
      <div style={{color:'black',backgroundColor:'white',textAlign:'center',opacity:'0.5',width:'80%',left:'10%',position:'absolute',top:'5%',padding:'5px'}}>
        <h3>「超神準姓名學-愛情配對」</h3>
        <h3>網站使用條款</h3>
        <p>1.你同意，在本網站測驗結果，皆做參考，因為結果造就任何損失，皆不負任何賠償。</p>
        <p>2.你同意，本網站測驗填下「姓名」，可作為商業，研究用途以及給予第三方人得知。</p>
        <p>3.你同意，在使用時，不利用駭客等手段，破壞本網站之運行，否則願意負法律責任。</p>
        <p>4.你同意，本網站所蒐集的資訊，視為本公司的財產，有權將您的資料轉移給第三人。</p>
        <p>5.你同意，不會深信本測驗結果，而去做出傷害別人感情的事，造成無法挽回的感情。</p>
        <h4>感謝您的配合，祝您能獲得好的愛情幸福。</h4>
      </div>
    // );
    );
  }
}

export default ServiceTerms;



// WEBPACK FOOTER //
// ./src/components/ServiceTerms.js